<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de Puertos">
        <div class="table-responsive">
          <div class="form-group form-inline pull-right">
            <!-- <button @click="newCompany" type="button" class="btn btn-primary">Nuevo</button> -->
          </div>
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Tiempo de ciclo (minutos)</th>
                <th>Total horas para ratio</th>
                <th>Margen</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(port, k) in ports" :key="k">
                <td>{{port.name}}</td>
                <td>
                  <b-col class="form-group" sm="5">
                    <input
                      type="number"
                      v-model="port.cycle_time"
                      class="form-control"
                    >
                  </b-col>
                </td>
                <td>
                  <b-col class="form-group" sm="5">
                    <input
                      type="number"
                      v-model="port.hours"
                      class="form-control"
                    >
                  </b-col>
                </td>
                <td>
                  <b-col class="form-group" sm="5">
                    <input
                      type="number"
                      v-model="port.timeframe"
                      class="form-control"
                    >
                  </b-col>
                </td>
                <td>
                  <div class="form-group form-inline">
                    <button
                      v-on:click="editPort(port)"
                      type="button"
                      class="btn btn-primary"
                    >Guardar</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import contextMenu from "vue-context-menu";
import api from "@/helpers/api";

export default {
  components: { contextMenu },
  methods: {
    editPort(port) {
      api.put(`port/${port.id}`, port).then(response => {
        this.$toastr.success('Puerto actualizado.', "Puerto", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      });
    },
    newCompany() {
      this.$router.push({
        path: `/company/new`
      });
    }
  },
  data() {
    return {
      ports: [],
      company: {},
      key: null
    };
  },
  mounted() {
    api.get("/ports").then(response => {
      this.ports = response.ports;
    });
  }
};
</script>
